package org.example.zone360.pages.widgets.methodologyWidget


import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignSelf
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowDown
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowUp
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.utils.getWidgetDetail
import kotlinx.browser.window
import org.example.zone360.components.debugPrintln
import org.example.zone360.components.getAvatarColor
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.WidgetDetailPayload
import org.example.zone360.models.WidgetDetailResponse
import org.example.zone360.theme.Palette
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Res
import org.jetbrains.compose.web.css.AlignSelf
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun MethodologyConsistencyDetailsModal(
    widgetNo: Int,
    widgetName: String,
    widgetColor: Color,
    data: WidgetDetailResponse?,
    consistentPrinciples: List<String>,
    widgetKey: String,
    onClose: () -> Unit
) {
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()
    var selectedSortColumn by remember { mutableStateOf<String?>(null) }
    var isAscending by remember { mutableStateOf(true) }

    var localData by remember { mutableStateOf<WidgetDetailResponse?>(null) }
    var isLoading by remember { mutableStateOf(true) }
    var localPrinciples by remember { mutableStateOf(consistentPrinciples) }

    // ✅ Fetch data
    LaunchedEffect(Unit) {
        isLoading = true
        try {
            localData = getWidgetDetail(
                WidgetDetailPayload(
                    organization = AppGlobal.userData.organization,
                    seasonID = AppGlobal.selectedSeasonId,
                    widgetKey = widgetKey
                )
            )

            localData?.let { response ->
                val allPrinciples = response.coaches.flatMap { it.consistentPrinciples }
                localPrinciples = allPrinciples.distinct()  // Remove duplicates
            }
        } catch (e: Exception) {
            debugPrintln("Failed to fetch widget detail: ${e.message}")  // ✅ Use println instead
            e.printStackTrace()
        } finally {
            isLoading = false
        }
    }
    // ✅ Effective data
    val effectiveData = data ?: localData
    val coachList = effectiveData?.coaches ?: emptyList()
    val clubAverage = effectiveData?.clubAverage?.toInt() ?: 0
    val effectivePrinciples = if (localData != null && localPrinciples.isNotEmpty()) localPrinciples else consistentPrinciples

    // Sorted coaches
    val sortedCoaches = when (selectedSortColumn) {
        "COACH" -> if (isAscending)
            coachList.sortedBy { it.coachName.lowercase() }
        else
            coachList.sortedByDescending { it.coachName.lowercase() }
        "SCORE" -> if (isAscending)
            coachList.sortedBy { it.score }
        else
            coachList.sortedByDescending { it.score }
        else -> coachList
    }

    // ── Backdrop ───────────────────────────────────────────────────────────
    Box(
        modifier = Modifier
            .styleModifier {
                property("position", "fixed")
                property("top", "0")
                property("left", "0")
                property("right", "0")
                property("bottom", "0")
                property("z-index", "99999")
                property("background-color", "rgba(0,0,0,0.7)")
                property("display", "flex")
                property("align-items", "center")
                property("justify-content", "center")
            }
            .onClick { onClose() }
    ) {
        // ── Modal panel ────────────────────────────────────────────────────
        Box(
            modifier = Modifier
                .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .borderRadius(16.px)
                .padding(24.px, if (breakpoint < Breakpoint.MD) 15.px else 25.px)
                .styleModifier {
                    property("width", "90%")
                    property("max-width", "450px")
                    property("max-height", "90vh")
                    property("overflow-y", "auto")
                    property("box-shadow", "0 20px 50px rgba(0,0,0,0.25)")
                }
                .onClick { it.stopPropagation() }
        ) {
            Column(modifier = Modifier.fillMaxWidth()) {

                // ── Header ─────────────────────────────────────────────────
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.fillMaxWidth().margin(bottom = 20.px)
                ) {
                    Box(
                        modifier = Modifier
                            .width(28.px).height(28.px)
                            .backgroundColor(Palette.CoachTalkPrimaryBlue.rgbLight,)
                            .borderRadius(6.px)
                            .margin(right = 10.px),
                        contentAlignment = Alignment.Center
                    ) {
                        FieldTitleTextNormalSimple(
                            text = widgetNo.toString(),
                            fontSize = 14.px,
                            fontWeight = 700,
                            color = sitePalette.bodyBackgroundSecondary.rgb
                        )
                    }
                    FieldTitleTextNormalSimple(
                        text = widgetName,
                        fontSize = if (breakpoint < Breakpoint.MD) 16.px else 18.px,
                        fontWeight = 700
                    )
                    Box(modifier = Modifier.styleModifier { property("flex", "1") })
                    Box(
                        modifier = Modifier.cursor(Cursor.Pointer).onClick { onClose() }
                    ) {
                        SpanText(
                            text = "✕",
                            modifier = Modifier.fontSize(18.px).fontWeight(700)
                        )
                    }
                }

                // ── Shield + Score ─────────────────────────────────────────
                Row(
                    modifier = Modifier
                        .fillMaxWidth().gap(25.px)
                        .margin(top = 8.px),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.Center
                ) {

                    // Premium Shield Container
                    Box(
                        modifier = Modifier
                            .size(100.px)
                            .borderRadius(50.percent)
                            .styleModifier {
                                property("position", "relative")
                            },
                        contentAlignment = Alignment.Center
                    ) {

                        // Main Circle
                        Box(
                            modifier = Modifier
                                .size(80.px)
                                .borderRadius(50.percent)
                                .backgroundColor(Colors.White)
                                .styleModifier {
                                    property(
                                        "box-shadow",
                                        "0 8px 25px rgba(59,130,246,0.15)"
                                    )
                                    property(
                                        "border",
                                        "2px solid rgba(59,130,246,0.15)"
                                    )
                                }
                        )

                        // Orbit Ring
                        Box(
                            modifier = Modifier
                                .size(100.px )
                                .borderRadius(50.percent)
                                .styleModifier {
                                    property(
                                        "border",
                                        "2px solid rgba(59,130,246,0.12)"
                                    )
                                }
                        )

                        // Shield
                        Image(
                            src = Res.Images.shield,
                            modifier = Modifier.size(72.px).borderRadius(50.percent)
                        )
                    }
                    Column(modifier = Modifier) {

                        // Score
                        FieldTitleTextNormalSimple(
                            text = "${clubAverage}%",
                            fontSize = 36.px,
                            fontWeight = 700,
                            color = widgetColor
                        )

                        FieldTitleTextNormalSimple(
                            text = "Consistent Principles",
                            fontSize = 13.px,
                            fontWeight = 600,
                            color = Color.rgb(107, 114, 128)
                        )
                    }
                }
//                Row(
//                    verticalAlignment = Alignment.CenterVertically,
//                    horizontalArrangement = Arrangement.Center,
//                    modifier = Modifier.fillMaxWidth().margin(bottom = 16.px).gap(25.px)
//                ) {
//                    Box(
//                        modifier = Modifier
//                            .size(100.px)
//                            .borderRadius(50.percent)
//                            .styleModifier {
//                                property(
//                                    "background",
//                                    "radial-gradient(circle at center, rgba(124,58,237,0.12), rgba(255,255,255,1) 70%)"
//                                )
//
//                                property(
//                                    "box-shadow",
//                                    """
//                    0 10px 35px rgba(124,58,237,0.12),
//                    0 0 0 8px rgba(124,58,237,0.03)
//                    """.trimIndent()
//                                )
//                            },
//                        contentAlignment = Alignment.Center
//                    ) {
//                        Image(
//                            src = Res.Images.shield,
//                            modifier = Modifier.size(72.px)
//                        )
//                    }
//                    Column {
//                        FieldTitleTextNormalSimple(
//                            text = "$clubAverage%",
//                            fontSize = 36.px,
//                            fontWeight = 700,
//                            color = widgetColor
//                        )
//                        FieldTitleTextNormalSimple(
//                            text = "Consistent Principles",
//                            fontSize = 13.px,
//                            fontWeight = 600,
//                            color = Palette.CoachTalkTableHeaderText.rgbLight
//                        )
//                    }
//                }
                // ── Consistent Principles list ─────────────────────────────
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .margin(top = if (breakpoint < Breakpoint.MD) 0.px else 14.px,
                            bottom = if (breakpoint < Breakpoint.MD) 0.px else 16.px),
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.Center
                ) {
                    if (consistentPrinciples.isEmpty()) {
                        Box(
                            modifier = Modifier.fillMaxWidth().height(60.px),
                            contentAlignment = Alignment.Center
                        ) {
                            FieldTitleTextNormalSimple(
                                text = "Loading principles...",
                                fontSize = 14.px,
                                fontWeight = 500,
                                color = Palette.CoachTalkTableHeaderText.rgbLight
                            )
                        }
                    } else {
                        consistentPrinciples.take(3).forEach { principle ->
                            Row(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .padding(leftRight = 27.percent)
                                    .margin(bottom = 10.px)
                                    .gap(15.px),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Box(
                                    modifier = Modifier
                                        .width(18.px).height(18.px)
                                        .backgroundColor(Color.rgb(34, 197, 94))
                                        .borderRadius(50.percent),
                                    contentAlignment = Alignment.Center
                                ) {
                                    SpanText(
                                        text = "✓",
                                        modifier = Modifier.fontSize(11.px).color(Colors.White)
                                    )
                                }
                                FieldTitleTextNormalSimple(
                                    text = principle,
                                    fontSize = 14.px,
                                    fontWeight = 500
                                )
                            }
                        }
                    }
                }

                // ── Club Avg ───────────────────────────────────────────────
                Box(
                    modifier = Modifier.backgroundColor(Palette.WidgetAverageBackground.rgbLight)
                        .borderRadius(99.px).alignSelf(AlignSelf.Center)
                        .margin(bottom = 20.px).padding(leftRight = 10.px, topBottom = 4.px),
                    contentAlignment = Alignment.Center
                ) {
                    FieldTitleTextNormalSimple(
                        text = "Club Avg: $clubAverage%",
                        fontSize = 14.px,
                        fontWeight = 500,
                        color = Palette.CoachTalkTableHeaderText.rgbLight
                    )
                }

                // ── Divider ────────────────────────────────────────────────
                Box(
                    modifier = Modifier
                        .fillMaxWidth().height(1.px)
                        .backgroundColor(Color.rgb(229, 234, 243))
                        .margin(bottom = 16.px)
                )

                // ── Table ──────────────────────────────────────────────────
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .borderRadius(12.px)
                        .styleModifier {
                            property("border", "1px solid #E5EAF3")
                            property("overflow", "hidden")
                        }
                ) {
                    // Header row
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .backgroundColor(Color.rgb(248, 250, 252))
                            .padding(leftRight = 20.px, topBottom = 10.px)
                            .borderBottom(1.px, LineStyle.Solid, Color.rgb(229, 234, 243)),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        listOf("COACH", "SCORE", "CONSISTENT PRINCIPLES").forEachIndexed { index, label ->
                            val colWidth = when (index) {
                                0 -> if (window.screen.width < 768) 110.px else 150.px
                                1 -> 70.px
                                else -> null // flex:1
                            }

                            Row(
                                modifier = Modifier
                                    .then(
                                        if (colWidth != null) Modifier.width(colWidth)
                                        else Modifier.styleModifier { property("flex", "1") }
                                    )
                                    .cursor(if (index < 2) Cursor.Pointer else Cursor.Default)
                                    .onClick {
                                        if (index < 2) {
                                            if (selectedSortColumn == label) isAscending = !isAscending
                                            else { selectedSortColumn = label; isAscending = true }
                                        }
                                    },
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                FieldTitleTextNormalSimple(
                                    text = label,
                                    fontSize = 11.px,
                                    fontWeight = 700,
                                    color = Color.rgb(107, 114, 128)
                                )
                                if (selectedSortColumn == label) {
                                    Box(modifier = Modifier.margin(left = 5.px)) {
                                        if (isAscending) FaArrowUp(
                                            modifier = Modifier.fontSize(10.px)
                                                .color(Palette.CoachHeaderGradientOne.rgbLight)
                                        ) else FaArrowDown(
                                            modifier = Modifier.fontSize(9.px)
                                                .color(Palette.CoachHeaderGradientOne.rgbLight)
                                        )
                                    }
                                }
                            }
                        }
                    }

                    // Body
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(if (breakpoint < Breakpoint.MD) 220.px else 280.px)
                            .overflow(Overflow.Auto)
                    ) {
                        sortedCoaches.forEachIndexed { rowIndex, coach ->
                            val avatarColor = getAvatarColor(coach.coachName)
                            val initials = coach.coachName
                                .split(" ").take(1)
                                .joinToString("") { it.firstOrNull()?.toString() ?: "" }
                                .uppercase()

                            Row(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .backgroundColor(
                                        if (rowIndex % 2 == 0) Colors.White
                                        else Color.rgb(250, 251, 252)
                                    )
                                    .padding(leftRight = 20.px, topBottom = 14.px)
                                    .borderBottom(1.px, LineStyle.Solid, Color.rgb(241, 245, 249)),
                                horizontalArrangement = Arrangement.SpaceBetween,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                // Coach
                                Row(
                                    modifier = Modifier
                                        .width(if (window.screen.width < 768) 110.px else 150.px),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Box(
                                        modifier = Modifier
                                            .width(if (breakpoint < Breakpoint.MD) 25.px else 32.px)
                                            .height(if (breakpoint < Breakpoint.MD) 25.px else 32.px)
                                            .backgroundColor(avatarColor.bg)
                                            .borderRadius(50.percent)
                                            .margin(right = 8.px),
                                        contentAlignment = Alignment.Center
                                    ) {
                                        SpanText(
                                            text = initials,
                                            modifier = Modifier
                                                .fontSize(11.px).fontWeight(700)
                                                .color(avatarColor.text)
                                        )
                                    }
                                    SpanText(
                                        text = coach.coachName,
                                        modifier = Modifier
                                            .fontSize(13.px).fontWeight(500)
                                            .overflow(Overflow.Hidden)
                                            .whiteSpace(WhiteSpace.NoWrap)
                                            .then(
                                                if (breakpoint < Breakpoint.MD) Modifier.width(60.px)
                                                else Modifier
                                            )
                                            .styleModifier {
                                                property("text-overflow", "ellipsis")
                                            }
                                    )
                                }

                                // Score
                                Box(modifier = Modifier.width(70.px)) {
                                    FieldTitleTextNormalSimple(
                                        text = "${coach.score}%",
                                        fontSize = 11.px,
                                        fontWeight = 500
                                    )
                                }

                                // Consistent Principles chips
                                Box(
                                    modifier = Modifier.styleModifier { property("flex", "1") }
                                ) {
                                    Row(
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .flexWrap(FlexWrap.Wrap)
                                            .gap(5.px)
                                    ) {
                                        // ✅ Show first principle
                                        coach.consistentPrinciples.firstOrNull()?.let { principle ->
                                            Row(
                                                verticalAlignment = Alignment.CenterVertically,
                                                modifier = Modifier
                                                    .backgroundColor(Color.rgba(34, 197, 94, 0.10f))
                                                    .borderRadius(999.px)
                                                    .padding(leftRight = 8.px, topBottom = 3.px)
                                                    .gap(4.px)
                                            ) {
                                                Box(
                                                    modifier = Modifier
                                                        .width(14.px).height(14.px)
                                                        .backgroundColor(Color.rgb(34, 197, 94))
                                                        .borderRadius(50.percent),
                                                    contentAlignment = Alignment.Center
                                                ) {
                                                    SpanText(
                                                        text = "✓",
                                                        modifier = Modifier
                                                            .fontSize(9.px).fontWeight(700)
                                                            .color(Colors.White)
                                                    )
                                                }
                                                SpanText(
                                                    text = principle,
                                                    modifier = Modifier
                                                        .fontSize(11.px).fontWeight(500)
                                                        .color(Color.rgb(22, 163, 74))
                                                        .whiteSpace(WhiteSpace.NoWrap)
                                                )
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}